class SamplePlayer {
  constructor(player) {
    this.player = player;
    this.audio = new Audio(player.dataset.audio);
    this.isPlaying = false;

    this.player.innerHTML = `
      <svg class="player__button__icon player__button__play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M8 5v14l11-7z"/>
      </svg>
    `;

    this.player.addEventListener('click', () => this.toggle());
    this.audio.addEventListener('ended', () => this.pause());

    if (player.dataset.progress) {
      this.progessbar = document.createElement('div');
      this.progessbar.classList.add('sample-player__progressbar');
      this.player.parentNode.append(this.progessbar);

      this.progessbar_fill = document.createElement('div');
      this.progessbar_fill.classList.add('sample-player__progressbar__fill');
      this.progessbar.append(this.progessbar_fill);

      this.audio.addEventListener('timeupdate', () => this.updateProgress());
      this.progessbar.addEventListener('mousedown', (event) => this.seek(event));
    }
  }

  toggle() {
    if (this.isPlaying) {
      this.pause();
      return;
    }

    if (window.activePlayer && window.activePlayer !== this) {
      window.activePlayer.pause();
    }

    this.play();
  }

  getProductCard() {
    return this.player.closest('.product-card-wrapper');
  }

  getBestSellingItem() {
    return this.player.closest('.bestselling__bestselling__item');
  }

  clearActiveStates() {
    document.querySelectorAll('.product-card-wrapper.card-active').forEach((card) => {
      card.classList.remove('card-active');
    });

    document.querySelectorAll('.bestselling__bestselling__item.player-active').forEach((item) => {
      item.classList.remove('player-active');
    });
  }

  setActiveState(isActive) {
    const productCard = this.getProductCard();
    const bestSellingItem = this.getBestSellingItem();

    if (productCard) {
      productCard.classList.toggle('card-active', isActive);
    }

    if (bestSellingItem) {
      bestSellingItem.classList.toggle('player-active', isActive);
    }
  }

  play() {
    this.clearActiveStates();
    window.activePlayer = this;

    const playPromise = this.audio.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch((error) => {
        console.error('Unable to play sample:', error);
        this.pause();
      });
    }

    this.isPlaying = true;
    this.player.parentNode.classList.add('player-active');
    this.setActiveState(true);
    this.updateButtonIcon(true);
  }

  pause() {
    this.audio.pause();
    this.isPlaying = false;

    this.player.parentNode.classList.remove('player-active');
    this.setActiveState(false);
    this.updateButtonIcon(false);

    if (window.activePlayer === this) {
      window.activePlayer = null;
    }
  }

  updateButtonIcon(isPlaying) {
    this.player.innerHTML = isPlaying
      ? `<svg class="player__button__icon player__button__pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
           <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
         </svg>`
      : `<svg class="player__button__icon player__button__play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
           <path d="M8 5v14l11-7z"/>
         </svg>`;
  }

  updateProgress() {
    if (!this.progessbar_fill || !this.audio.duration) return;

    this.progessbar_fill.style.width =
      `${(this.audio.currentTime / this.audio.duration) * 100}%`;
  }

  seek(event) {
    if (!this.progessbar || !this.audio.duration) return;

    const rect = this.progessbar.getBoundingClientRect();
    const position = (event.clientX - rect.left) / rect.width;

    this.audio.currentTime = position * this.audio.duration;
  }
}
